import { render, staticRenderFns } from "./TransactionPage.vue?vue&type=template&id=366c6a37"
import script from "./TransactionPage.vue?vue&type=script&lang=js"
export * from "./TransactionPage.vue?vue&type=script&lang=js"
import style0 from "./TransactionPage.vue?vue&type=style&index=0&id=366c6a37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports